import { ApolloCache, Reference } from "@apollo/client"
import { TRANSPORTER_FRAGMENT } from "../fragment/transporter"

export const updateCacheTransporter = ({
  cache,
  entryData,
  action,
}: {
  cache: ApolloCache<any>
  entryData: any
  action: "update" | "delete" | "add"
}) => {
  return cache.modify({
    fields: {
      transporters(existing = []) {
        const newTransporterRef = cache.writeFragment({
          data: entryData,
          fragment: TRANSPORTER_FRAGMENT,
        })
        switch (action) {
          case "add":
            return [...existing, newTransporterRef]
          case "delete":
            return [
              ...existing?.filter(
                (el: Reference | undefined) =>
                  el?.__ref !== newTransporterRef?.__ref,
              ),
            ]
          case "update":
            const index = existing.findIndex(
              (el: Reference | undefined) =>
                el?.__ref !== newTransporterRef?.__ref,
            )
            const items = [...existing]
            if (index > -1) {
              items[index] = newTransporterRef
            }
            return items
        }
      },
      aggregateTransporter(existing = {}) {
        let _all = existing?._count?._all
        switch (action) {
          case "add":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all + 1 : 0,
              },
            }
          case "delete":
            return {
              ...existing,
              _count: {
                ...existing?._count,
                _all: _all ? _all - 1 : 0,
              },
            }
        }
      },
    },
  })
}
